import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { CalendarResponse } from "../contracts/CalendarResponse";
import { CalendarItem } from "../models/CalendarItem";
import { CalendarItemResponseMapper } from "../mappers/CalendarItemResponseMapper";

const mapper = new CalendarItemResponseMapper();

export interface CalendarFeed {
  from: string;
  to: string;
  items: CalendarItem[];
}

/**
 * Load the organization's calendar feed — every occurrence (including cancelled
 * ones) across all active sessions in the inclusive [from, to] range.
 * An optional instructorId narrows the feed to one colleague's sessions.
 */
export const fetchCalendar = createAsyncThunk<
  CalendarFeed,
  { from: string; to: string; instructorId?: string },
  { rejectValue: ApiErrorResponse }
>("calendar/fetch", async ({ from, to, instructorId }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<CalendarResponse>("/bookings/calendar", {
      params: instructorId ? { from, to, instructorId } : { from, to },
    });
    return {
      from: response.data.from,
      to: response.data.to,
      items: mapper.toItems(response.data.items),
    };
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to load the calendar"));
  }
});
